import { AI_SETTINGS_INITIAL_STATES } from '../initial-states'

const aiSettingsReducer = (state = AI_SETTINGS_INITIAL_STATES, action) => {
  switch (action.type) {
    default:
      return state
  }
}

export default aiSettingsReducer
